import { UNSAVED_CHANGES_MESSAGE } from '../../constants/data';
import { SAVED_SEARCH_PAGE_ROUTE } from '../../constants/routes';
import type { AppDispatch, GetState } from '../../store/types';
import { setPanelPristineById } from './pristine/slice';
import { closePanelById } from './slice';

export function closePanel(panelId: string) {
  return (dispatch: AppDispatch, getState: GetState) => {
    const panelsPristine = getState().panelsPristine;
    const pageRoute = getState().routeParams.route;
    const isDirty = panelsPristine[panelId] === false;
    if (isDirty && pageRoute !== SAVED_SEARCH_PAGE_ROUTE) {
      const accepted = window.confirm(UNSAVED_CHANGES_MESSAGE);
      if (accepted) {
        dispatch(closePanelById(panelId));
        dispatch(setPanelPristineById(panelId));
      }
    } else {
      dispatch(closePanelById(panelId));
    }
  };
}
